import { ImdfFeature } from "providers/venue/types"
import { Id } from "@turf/helpers"
import { Model3d, Model3dData } from "../../../../types"
import {
  LevelFeature,
  OccupantFeature,
  AmenityFeature,
  UnitFeature,
  KioskFeature,
} from "venue-react"

export const prepareModel3dData = (
  model3d: Model3d,
  findOne: <T = ImdfFeature>(id: Id) => T
): Model3dData => {
  const { level_id, feature_id } = model3d.properties
  const level = findOne<LevelFeature>(level_id)
  const feature = findOne<
    OccupantFeature | AmenityFeature | UnitFeature | KioskFeature
  >(feature_id)

  return {
    ...model3d,
    properties: {
      ...model3d.properties,
      level,
      feature,
    },
  }
}
